import { render, staticRenderFns } from "./TabRedactorSummaryOrders.vue?vue&type=template&id=7037cf36&"
import script from "./TabRedactorSummaryOrders.vue?vue&type=script&lang=js&"
export * from "./TabRedactorSummaryOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports